import React from 'react';
import { Note, User } from '../../types';
import { NoteCard } from './NoteCard';
import { FileText } from 'lucide-react';
interface NotesFeedProps {
  notes: Note[];
  onReply: (parentId: string, content: string, taggedUsers?: User[]) => void;
  onDelete: (noteId: string) => void;
  availableUsers?: User[];
}
function groupNotesByDate(notes: Note[]): {
  label: string;
  notes: Note[];
}[] {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today.getTime() - 86400000);
  const weekAgo = new Date(today.getTime() - 7 * 86400000);
  const groups: Record<string, Note[]> = {};
  notes.forEach(note => {
    const date = new Date(note.createdAt);
    const noteDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    let label: string;
    if (noteDay.getTime() === today.getTime()) {
      label = 'Today';
    } else if (noteDay.getTime() === yesterday.getTime()) {
      label = 'Yesterday';
    } else if (noteDay >= weekAgo) {
      label = 'This Week';
    } else {
      label = new Intl.DateTimeFormat('en-US', {
        month: 'long',
        year: 'numeric'
      }).format(date);
    }
    if (!groups[label]) groups[label] = [];
    groups[label].push(note);
  });
  const order = ['Today', 'Yesterday', 'This Week'];
  const sorted = Object.entries(groups).sort(([a], [b]) => {
    const ai = order.indexOf(a);
    const bi = order.indexOf(b);
    if (ai !== -1 && bi !== -1) return ai - bi;
    if (ai !== -1) return -1;
    if (bi !== -1) return 1;
    return 0;
  });
  return sorted.map(([label, notes]) => ({
    label,
    notes
  }));
}
export function NotesFeed({
  notes,
  onReply,
  onDelete,
  availableUsers = []
}: NotesFeedProps) {
  if (notes.length === 0) {
    return <div className="flex flex-col items-center justify-center py-16 text-center" data-id="element-201">
        <div className="h-12 w-12 rounded-full bg-slate-100 flex items-center justify-center mb-3" data-id="element-202">
          <FileText className="h-6 w-6 text-slate-400" data-id="element-203" />
        </div>
        <p className="text-sm font-medium text-slate-600" data-id="element-204">No notes found</p>
        <p className="text-xs text-slate-400 mt-1" data-id="element-205">
          Try adjusting your filters or add a new note.
        </p>
      </div>;
  }
  const groups = groupNotesByDate(notes);
  return <div className="space-y-6" data-id="element-206">
      {groups.map(({
      label,
      notes: groupNotes
    }) => <div key={label} data-id="element-207">
          {/* Date group label */}
          <div className="flex items-center gap-3 mb-4" data-id="element-208">
            <span className="text-xs font-semibold text-slate-400 uppercase tracking-wider whitespace-nowrap" data-id="element-209">
              {label}
            </span>
            <div className="flex-1 h-px bg-slate-200" data-id="element-210" />
          </div>
          <div data-id="element-211">
            {groupNotes.map(note => <NoteCard key={note.id} note={note} onReply={onReply} onDelete={onDelete} availableUsers={availableUsers} data-id="element-212" />)}
          </div>
        </div>)}
    </div>;
}